import React, { useState, useMemo, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
    progressProgressRing: {
        padding: theme.spacing(3, 4),
        paddingBottom: theme.spacing(2),
        margin: "0 auto",
    },
    progressProgressRingLabel: {},
    progressProgressRingGroove: {
        width: "100%",
        stroke: "currentColor",
        opacity: "0.1",
        position: "absolute",
        height: "100%",
    },
    progressProgressRingProgress: {
        width: "10px",
        stroke: ({ percent }) => {
            if (percent <= 33) {
                return "#f21c20"
            }
            if (percent > 33 && percent < 66) {
                return "#ed9e14"
            }
            if (percent >= 66 && percent < 100) {
                return "#52b9e9"
            }
            return "#1bd422"
        },
        strokeDasharray: ({ style }) => {
            return style.strokeDasharray
        },
        strokeDashoffset: ({ style }) => {
            return style.strokeDashoffset
        },
    },
    progressProgressRingSVGWrapper: {
        position: "relative",
    },
}))

const ProgressRing = memo((props) => {
    const { progress, outOf, label } = props

    const percent = useMemo(() => {
        return progress > 0 ? Math.round((progress / outOf) * 100) : 0
    }, [progress, outOf])

    const [circumference] = useState(() => {
        return 23 * 2 * Math.PI
    })

    const style = useMemo(() => {
        return {
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset: circumference - (percent / 100) * circumference,
        }
    }, [progress, outOf])

    const styleProps = {
        percent,
        style,
    }

    const classes = useStyles(styleProps)
    return (
        <div className="ring">
            <Box className={classes.progressProgressRing} title={label}>
                <svg viewBox="0 0 54 54" className={classes.progressProgressRingSVGWrapper}>
                    <circle className={classes.progressProgressRingProgress} strokeWidth="8" fill="transparent" r="23" cx="27" cy="27" />
                    <circle className={classes.progressProgressRingGroove} strokeWidth="8" fill="transparent" r="23" cx="27" cy="27" />
                </svg>
            </Box>
        </div>
    )
})

export default ProgressRing
